import React from 'react'

// Plans entitlements checkbox
export const EntCheckboxInput = ({
  checked,
  onChange = () => {},
  label,
  disabled,
}) => {
  return (
    <label
      className={`checkbox-btn ${disabled ? 'disabled' : ''} 
      ${checked && !disabled ? 'checked' : ''}`}
      //   onClick={() => !disabled && onChange()}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={e => {
          !disabled && onChange()
        }}
      />
      <span>{label}</span>
    </label>
  )
}
